/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import Loading from 'components/Loading/Loading';
import { Carousel } from '../../../../components/Carousel/Carousel';
import ElectroCheckList from 'forms/components/inputs/ElectroCheckList/ElectroCheckList';
import ActionDrawerFormButtons from 'views/ActionDrawer/components/ActionDrawerFormButtons/ActionDrawerFormButtons';
import ActionDrawerBlock from 'views/ActionDrawer/components/ActionDrawerBlock/ActionDrawerBlock';
import ActionDrawerTable from 'views/ActionDrawer/components/ActionDrawerTable/ActionDrawerTable';
import ActionDrawerWarnings from 'views/ActionDrawer/components/ActionDrawerWarnings/ActionDrawerWarnings';
import endpoints from 'api/endpoints';
import styles from '../../../../ActionDrawer.module.scss';

import type TypeForm from 'forms/_.extend';
import type { TranslatorProps } from 'react-i18next';
type TypeProps = {
  t: TranslatorProps,
  asset: Object,
  assetStore: Object,
  form: TypeForm,
};

@translate()
@inject('assetStore')
@observer
export default class ReassignAssetForm extends React.Component<*> {
  renderAssetBlock(asset) {
    const { t, assetStore } = this.props;
    const assetDetails = asset.account
      ? asset
      : assetStore.assets.filter(item => item.id === asset.id)[0];

    const assetInfo = [
      [
        t('general:trading_account'),
        assetDetails.account && `${assetDetails.account.name} ${assetDetails.account.number}`,
      ],
      [t('general:assets.labels.number'), assetDetails.asset_number],
      [t('general:manufacturer'), assetDetails.manufacturer],
      [t('general:model'), assetDetails.model],
      [t('general:labels.serial_number'), assetDetails.serial_number],
    ];

    return <ActionDrawerTable data={assetInfo} />;
  }

  renderCarousel() {
    const { t, assetStore, assets, form } = this.props;

    return (
      <ActionDrawerBlock
        divider={false}
        gutters={true}
        heading={t('general:assets.labels.details')}
      >
        <Carousel className={styles['carousel']}>
          {assets.map(assetItem => {
            const assetUser = assetStore.assets.filter(item => item.id === assetItem.id)[0].user;
            return (
              <React.Fragment key={assetItem.id}>
                {this.renderAssetBlock(assetItem)}
                {assetUser && assetUser.name && (
                  <ActionDrawerBlock divider={false} gutters={false}>
                    <div>
                      <b>{t('general:assets.currently_assigned_to')}:</b>
                    </div>
                    <ul>
                      <li>{assetUser.name}</li>
                      <li>{`${t('general:roles.labels.current_role')}: ${assetUser.role}`}</li>
                    </ul>
                    <div className={styles['reassign-asset-warning']}>
                      <ActionDrawerWarnings
                        field={form.$(`assetWarnings.${assetItem.id}`)}
                        warnings={form.$(`assetWarnings.${assetItem.id}`).extra.warnings}
                      />
                    </div>
                  </ActionDrawerBlock>
                )}
              </React.Fragment>
            );
          })}
        </Carousel>
      </ActionDrawerBlock>
    );
  }

  render() {
    const { t, form, assetStore }: TypeProps = this.props;
    const user = JSON.parse(localStorage.getItem('user'));

    if (assetStore.loadingAssets) {
      return <Loading />;
    }

    const asset = assetStore.assets[0];

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          {this.renderCarousel()}
          <ElectroCheckList
            field={form.$('reassignAssetTo.assigneeId')}
            type="radio"
            heading={form.$('reassignAssetTo').label}
            endpoint={`${endpoints.accounts}/${asset.account.id}/users`}
            enableSearch={true}
            searchKeys={['first_name', 'last_name']}
            exclude={[asset.user.id]}
            customResponse={(response: *) => {
              let arr: Array<Object> = [];

              for (const key: string in response) {
                if (Object.prototype.hasOwnProperty.call(response, key)) {
                  arr = arr.concat(response[key]);
                }
              }

              return arr;
            }}
            primaryLiteral={(item: Object) => {
              return item.id === user.id ? (
                <React.Fragment>
                  <strong>Me</strong>&nbsp;({`${item.first_name} ${item.last_name}`})
                </React.Fragment>
              ) : (
                `${item.first_name} ${item.last_name}`
              );
            }}
            secondaryLiteral={(item: Object) => (
              <React.Fragment>
                Current role: <strong>{t(`general:roles.${item.role_id}`)}</strong>
              </React.Fragment>
            )}
          />
        </div>
        <ActionDrawerFormButtons form={form} submitTxt={t('general:actions.reassign')} />
      </React.Fragment>
    );
  }
}
